import { jsx as _jsx } from "react/jsx-runtime";
import { lazy } from "react";
import { useConfigurationLanguage } from "@plansoft-configuration-renderer/framework";
import { useConfigurationLogEventsSockets } from "./useConfigurationLogEventsSockets";
// import { useConfigurationLogEventPolling } from "./useConfigurationLogEventPolling";
const LogViewerTable = lazy(() => import("./LogViewerTable"));
export function ConfigurationEventLogViewer(props) {
    const { logEvents } = useConfigurationLogEventsSockets();
    const localeCode = useConfigurationLanguage();
    return (_jsx(LogViewerTable, { logEvents: logEvents, localeCode: localeCode, maxHeight: props.maxHeight }));
}
//# sourceMappingURL=ConfigurationEventLogViewer.js.map